<template>
  <v-form v-model="formValid" ref="myForm" class="w-100 create-personal align-items-center d-flex  w-100 px-3 pt-3 pb-5 mb-3">
      <div class="pr-3 form-foto">
            <!-- FOTO -->
          <v-avatar
            class=""
            size="100px">
            <v-img
            class="error-img"
              :class='currentStatus === STATUS_PHOTO.STATUS_CARGANDO ? "persona-foto-loading" : "persona-foto"'
              @click='currentStatus !== STATUS_PHOTO.STATUS_CARGANDO ? $refs.fileInput.click() : null'
              :src='photoSource'
            ></v-img>
            <v-btn 
              @click='currentStatus !== STATUS_PHOTO.STATUS_CARGANDO ? $refs.fileInput.click() : null'
              fab
              absolute
              small
              flat
            
              class="primary">
                <!--<img class='btn-footer-der pointer' src='@/assets/images/Btn_F2.gif' >-->
                <v-icon>add_a_photo</v-icon>
            </v-btn>
        </v-avatar>
        
        <!-- FIN. FOTO -->
          <input
            type="file" 
            @change="onFileChange($event)" accept="image/*" 
            class="input-file"
            ref='fileInput' 
            style="display:none"/>  
        </div>        
      <div class="form-datos pr-2 w-100 d-flex flex-wrap ">
        <div class="col-25">
          <v-text-field
            :label=" $t('lang.personas.alias')"
            ref='ialias'
            id='ialias'
            class="mx-2"
            v-model='personaParam.mspersonaalias'
            :rules="[rules.aliasDim]"
            type='text'>
          </v-text-field>
        </div>
           <!-- DNI -->
        <div class="col-25">
          <!-- CAMBIO el DNI ya no es obligatorio -->
          <v-text-field
           :label="$t('lang.personas.dni')"
            ref='idni'
            id='idni'
            class="mx-2"
            v-model='personaParam.mspersonadni'
            type='text'>
          </v-text-field>
          <!-- <v-text-field
           :label="$t('lang.personas.dni')"
            ref='idni'
            id='idni'
            class="mx-2"
            v-model='personaParam.mspersonadni'
            :rules="[rules.required, rules.dni]"
            type='text'>
          </v-text-field> -->
        </div>
        <div class="col-25">
        <!-- NOMRE, APELLIDO1, APELLIDO2 -->
          <!-- NOMBRE -->
          <v-text-field
            :label=" $t('lang.personas.nombre') "
            ref='inombre'
            id='inombre'
            v-model='personaParam.mspersonanombre'
            :rules="[rules.nombreDim, rules.required]"
            class="mx-2"
            type='text'>
          </v-text-field>
        </div>
        <div class="col-25">
           <v-text-field
            :label="$t('lang.personas.apellidos')"
            ref='iapellido1'
            id='iapellido1'
            class="mx-2"
            v-model='personaParam.mspersonaapellido1'
            :rules="[rules.apellido1Dim]"
            type='text'>
          </v-text-field>
        </div>
       <v-divider class="w-100 mb-2"></v-divider>       
        <div class="col-33">
           <v-select
            ref='ipais'
            v-model='personaParam.mspersonapais'
            :items="paises"
            class="mx-2"
            :label="$t('lang.personas.pais')"
            item-text="mspaisnomesp"
            item-value="mspaisid"
            @change="paisChange"
          ></v-select>
        </div>
        <div class="col-33">
          <v-select
          ref='iprovincia'
          class="mx-2"
          :items="provincias"
          :label="$t('lang.personas.provincia') "
          item-text="msprovincianomesp"
          item-value="msprovinciaid"
           v-model='personaParam.mspersonaprovincia'
          >
          </v-select>
        </div>
        <div class="col-33">
           <v-text-field
            ref='ipoblacion'
            id='ipoblacion'
            class="mx-2"
            :label="$t('lang.personas.poblacion') "
            v-model='personaParam.mspersonapoblacion'
            :rules="[rules.poblacionDim]"
            type='text'>
          </v-text-field>
        </div>      
 
        <div class="col-66"> 
          <!-- DIRECCION -->
          <v-text-field
            ref='icalle'
            id='icalle'
            class="mx-2"
            :label="$t('lang.personas.direccion') "
            v-model='personaParam.mspersonacalle'
            :rules="[rules.direccionDim]"
            type='text'>
          </v-text-field>
        </div>
         
        <div class="col-33">
          <!-- CP -->
          <v-text-field
            :label="$t('lang.personas.cp')"
            ref='icp'
            id='icp'
            class="mx-2"
            v-model='personaParam.mspersonacodpostal'
            :rules="[rules.cpDim]"
            >
          </v-text-field>
        </div>
        <v-divider class="w-100 mb-2"></v-divider>
        <!-- Direccion, CP -->  
        <!-- FIN Direccion, CP  
        -->
          <!-- TELEFONO -->
        <!-- FIN email, movil, Telefono -->
        <div class="col-33">
           <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="personaParam.mspersonafechanac"
                class="mx-2"
                :label="$t('lang.personas.fechanac') "
                append-icon="event"
                :rules="[rules.fechanac]"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="personaParam.mspersonafechanac"
              no-title
              color="primary"
              @input="menu2 = false"
            ></v-date-picker>
          </v-menu>
        </div>    
        <div class="col-33">
          <v-text-field
            :label="$t('lang.personas.telefono') "
            ref='itelefono'
            id='itelefono'
             class="mx-2"
            v-model='personaParam.mspersonatel'
            type='tel'>
          </v-text-field>
        </div>
        <div class="col-33">
           
          <v-text-field
            :label="$t('lang.personas.movil') "
            ref='imovil'
            id='imovil'
            class="mx-2"
            v-model='personaParam.mspersonatelmovil'
            :rules="[rules.required, rules.movil, rules.movilDim]"
            type='tel'>
          </v-text-field>
        </div>
        <div class="col-33">
          <!-- EMAIL -->
          <v-text-field
            :label="$t('lang.personas.email')"
            ref='iemail'
            id='iemail'
            class="mx-2"
            v-model='personaParam.mspersonaemail'
            :rules="[rules.required, rules.email]"
            type='email'>
          </v-text-field>
        </div>  
        <!-- password -->
          <div class="col-33">
            <!-- password -->
            <v-text-field
             :label="$t('lang.personas.contrasenha')"
              ref='ipassword'
              id='ipassword'
              class="mx-2"
              v-model='pass'
              :rules="[rules.required]"
              type='password'
              >
            </v-text-field>
          </div>
          <div class="col-33">
            <!-- password -->
            <v-text-field
              :label="'Rep. '+ $t('lang.personas.contrasenha')"
              ref='ireppassword'
              id='ireppassword'
              class="mx-2"
              v-model='repPass'
              :rules="[rules.required]"
              type='password'
              >
            </v-text-field>
          </div>
      </div>
        <!-- FIN password -->
          <v-btn large dark fab absolute bottom right class="orange guardar" @click='guardar()'>
            <!-- {{ $t('lang.comun.guardar') }}-->
            <v-icon>save</v-icon>
          </v-btn>
  </v-form>
</template>
<script>
import { PersonaApiService } from '@/api/PersonaApiService'
import { PaisApiService } from '@/api/PaisApiService'
import { ProvinciaApiService } from '@/api/ProvinciaApiService'
import { Util } from '@/api/Util'

const personaApiService = new PersonaApiService()
const paisApiService = new PaisApiService()
const provinciaApiService = new ProvinciaApiService()
const util = new Util()

export default {
  data () {
    return {     
      formValid: false,   
      menu2: false,
      user: this.$store.getters.getUserName,
      paises: [],
      provincias: [],
      isMountedDatos: false,
      urlImagen: process.env.VUE_APP_URL_API_PERSONA + 'getPersonaFoto/',
      currentStatus: 0,
      urlImagenPreview: null,
      urlImagenLoading: require('@/assets/images/spinner.gif'),
      imgFile: null,
      isMountedFoto: false,
      STATUS_PHOTO: {
        STATUS_INICIAL: 0,
        STATUS_CORRECTO: 1,
        STATUS_CARGANDO: 2
      },
      msj: {
        borrarFoto: this.$t('lang.msjconfirm.borrarfoto'),
        correcto: this.$t('lang.personas.alerta.correcto'),
        errorimagen: 'Error'
        // errorimagen: this.$t('lang.personas.alerta.errorImagen')
      },
      // Caracteres máximos de los inputs
      maxchar: {
        mspersonaaliasmaxchars: 128,
        mspersonanombremaxchars: 128,
        mspersonaapellido1maxchars: 50,
        mspersonaapellido2maxchars: 50,
        mspersonacallemaxchars: 128,
        mspersonacodpostalmaxchars: 20,
        mspersonapoblacionmaxchars: 128,
        mspersonatelmaxchars: 25,
        mspersonatelmovilmaxchars: 25,
        mspersonaemailmaxchars: 128
      },
      personaParam: {
        mspersonaalias: "",
        mspersonanombre: "",
        mspersonaapellido1: "",
        mspersonaapellido2: "",
        mspersonacalle: "",
        mspersonacodpostal: "",
        mspersonapais: "ES",
        mspersonaprovincia:"ES @",
        mspersonapoblacion: "",
        mspersonatel: "",
        mspersonatelmovil: "",
        mspersonaemail: "",
        mspersonadni: "",
        mspersonafechanac: "",
        mspersonasexo: "",
        mspersonausualta: "",
        mspersonapassword: "",
        mspersonaimagen: "",
        mspersonaconfoto: "N", //por defecto la creamos sin foto
        imagen: null
      },
      rules: {
        required: value => !!value || this.$t('lang.error.camposObligatorios'),
        aliasDim: () => this.validAliasDim() || this.$t('lang.error.caracteresMaximos'),
        nombreDim: () => this.validNombreDim() || this.$t('lang.error.caracteresMaximos'),
        apellido1Dim: () => this.validApellido1Dim() || this.$t('lang.error.caracteresMaximos'),
        direccionDim: () => this.validDireccionDim() || this.$t('lang.error.caracteresMaximos'),
        cpDim: () => this.validCpDim() || this.$t('lang.error.caracteresMaximos'),
        poblacionDim: () => this.validPoblacionDim() || this.$t('lang.error.caracteresMaximos'),
        movilDim: () => this.validTelMovilDim() || this.$t('lang.error.caracteresMaximos'),
        dni: () => this.validDniFormat() || this.$t('lang.error.formatoIncorrecto'),
        email: () => this.validEmailFormat() || this.$t('lang.error.formatoIncorrecto'),
        movil: () => this.validTelFormat() || this.$t('lang.error.formatoIncorrecto'),
        fechanac: () => this.validFechaNacFormat() || this.$t('lang.error.formatoIncorrecto'),
        
      },
      pass: '',
      repPass: ''
    }
  },
  props: {
    tabSeleccionado: Number,
    clickCrearPersona: Number
  },
  mounted () {
    this.cambioTitulo()
    this.init()
  },
  watch: {
    personaParam: {
      handler (n, o) {
        if (n.mspersonaid !== o.mspersonaid) {
          this.reset(n)
        }
      },
      deep: true
    },
    paises: {
      handler (n, o) {
        // Seleccionamos el primer input
        this.$refs.ialias.focus()
      },
      deep: true
    },
    clickCrearPersona: {
      handler (n, o) {
        this.guardar()
      },
      deep: true
    }
  },
  methods: {
    init () {
      this.getAllPais()
      this.getProvinciasByPais()
      if (this.personaParam.mspersonapais === null || this.personaParam.mspersonapais === '') {
        this.personaParam.mspersonapais = 'ES'
      }
      if (this.personaParam.mspersonaprovincia === null || this.personaParam.mspersonaprovincia === '') {
        this.personaParam.mspersonaprovincia = ''
      }
    },
    // salir () {
    //   this.$router.push('/Personal')
    // },
    cambioTitulo () {
      this.$store.state.tituloIcono = `<v-icon class="v-icon material-icons primary-color">group</v-icon>`
      this.$store.state.titulo = "Control usuario"
    },
    // mountListenerTeclas () {
    //   // Anhadimos el listener para guardar (Tecla FIN=35)
    //   window.addEventListener('keyup', (e) => {
    //     if (e.keyCode === 35) {
    //         this.guardar()
    //     } else if (e.keyCode === 27) { // ESC
    //       this.salir()
    //     }
    //   })
    //   this.isMountedDatos = true
    // },
    reset (persona) {
      this.getProvinciasByPais()
      if (persona.mspersonapais === null || persona.mspersonapais === '') {
        this.personaParam.mspersonapais = 'ES'
      }
      // Seleccionamos el primer input
      this.$refs.ialias.focus()
    },
    paisChange () {
      this.personaParam.mspersonaprovincia = ''
      this.getProvinciasByPais()
    },
    getAllPais () {
      if (this.personaParam) {
        paisApiService.getAllPais()
          .then(data => {
            util.mostrarEnConsola('PersonasTabDatosPersonales - getAllPais', data.length, 'OK')
            this.paises = data
          })
          .catch(error => {
            util.mostrarEnConsola('PersonasTabDatosPersonales - getAllPais', error, 'ERROR')
          })
      }
    },
    getProvinciasByPais () {
      if (this.personaParam) {
        provinciaApiService.getProvinciasByPais(this.personaParam.mspersonapais)
          .then(data => {
            util.mostrarEnConsola('PersonasTabDatosPersonales - getProvinciasByPais', data.length, 'OK')
            this.provincias = data
          })
          .catch(error => {
            util.mostrarEnConsola('PersonasTabDatosPersonales - getProvinciasByPais', error, 'ERROR')
          })
      }
    },
    showCorrectAlert (mensaje) {
      this.$root.$emit('mostrarAlerta', mensaje, 'info')
    },
    showErrorAlert (mensaje) {
      this.$root.$emit('mostrarAlerta', mensaje, 'error')
    },
    guardar () {
      this.$refs.myForm.validate()
      if (this.formValid) {
        if (this.pass !== this.repPass) {
          this.showErrorAlert("Las contraseñas no coinciden")
        } else {
          this.personaParam.mspersonausualta = this.user.substring(0,50)
          this.personaParam.mspersonausumodif = this.user.substring(0,50)
          this.personaParam.mspersonapassword = this.pass
          personaApiService.createPersona(this.personaParam)
            .then(data => {
              if (data.status === 200) {
                if (data.data === "El DNI ya existe") {
                  this.showErrorAlert(data.data)
                } else if (data.data === "El email ya existe en el sistema") {
                  this.showErrorAlert(data.data)
                } else {
                  this.personaParam.mspersonaid = data.data.mspersonaid
                  this.guardarImagen()
                  // util.mostrarEnConsola('PersonasTabDatosPersonales - createPersona', data.status, 'OK')
                  //Ahora guardamos la foto
                  // Guardamos en sesion la persona
                  sessionStorage.setItem('personaAux', JSON.stringify(this.personaParam))
                  this.$emit('recargaPersonas')
                  this.personaParam.mspersonaalias = ""
                  this.personaParam.mspersonanombre = ""
                  this.personaParam.mspersonaapellido1 = ""
                  this.personaParam.mspersonaapellido2 = ""
                  this.personaParam.mspersonacalle = ""
                  this.personaParam.mspersonacodpostal = ""
                  this.personaParam.mspersonapais = "ES"
                  this.personaParam.mspersonaprovincia = ""
                  this.personaParam.mspersonapoblacion = ""
                  this.personaParam.mspersonatel = ""
                  this.personaParam.mspersonatelmovil = ""
                  this.personaParam.mspersonaemail = ""
                  this.personaParam.mspersonadni = ""
                  this.personaParam.mspersonafechanac = ""
                  this.personaParam.mspersonasexo = ""
                  this.personaParam.mspersonapassword =""
                  this.personaParam.mspersonaimagen=""
                  this.pass = ""
                  this.repPass = ""
                  this.formValid = false
                  this.showCorrectAlert(this.$t('lang.personas.alerta.creado'))
                }
              }
            })
            .catch(error => {
              this.showErrorAlert(this.$t('lang.personas.alerta.error'))
              util.mostrarEnConsola('PersonasTabDatosPersonales - createPersona', error, 'ERROR')
            })
        }
      }
    },
    guardarImagen () {
      if (this.currentStatus === this.STATUS_PHOTO.STATUS_CORRECTO) {
        personaApiService.updatePersonaFoto(this.personaParam)
          .then(data => {
            // this.personaParam.mspersonaconfoto = 'N'
            this.currentStatus = this.STATUS_PHOTO.STATUS_CARGANDO
            this.personaParam.mspersonaimagen = data.data.mspersonaimagen
            setTimeout(() => {
              // this.personaParam.mspersonaconfoto = 'S'
              this.currentStatus = this.STATUS_PHOTO.STATUS_INICIAL
              this.showCorrectAlert(this.msj.correcto)
            }, 1000)
            this.personaParam.imagen = null
            util.mostrarEnConsola('CreatePersona - updatePersonaFoto', data.status, 'OK')
          })
          .catch(error => {
            this.resetImagen()
            this.personaParam.imagen = null
            this.showErrorAlert(this.msj.errorimagen)
            util.mostrarEnConsola('CreatePersona - updatePersonaFoto', error, 'ERROR')
          })
      }
    },
    resetImagen () {
      // reiniciamos el estado de subida de imagenes
      this.personaParam.imagen = null
      this.currentStatus = this.STATUS_PHOTO.STATUS_INICIAL
      const input = this.$refs.fileInput
      input.type = 'text'
      input.type = 'file'
      this.imgFile = null
    },
    getImgPreview: function () {
      return this.urlImagenPreview
      // return URL.createObjectURL(this.imgFile)
    },
    onFileChange (e) {
      const file = e.target.files[0]
      if (file) {
        this.urlImagenPreview = URL.createObjectURL(file)
        this.currentStatus = this.STATUS_PHOTO.STATUS_CORRECTO
        this.personaParam.imagen = this.$refs.fileInput.files[0]
      }
    },
    validAliasDim: function () {
      if (this.personaParam) {
        if (util.isValidStringField(this.personaParam.mspersonaalias, this.maxchar.mspersonaaliasmaxchars)) {
          return true
        } else {
          return false
        }
      }
    },
    validDniFormat: function () {
      if (this.personaParam) {
        if (!util.isValidDni(this.personaParam.mspersonadni)) {
          return false
        } else {
          return true
        }
      }
    },
    validDniObligatorio: function () {
      if (this.personaParam) {
        if (util.isEmptyField(this.personaParam.mspersonadni)) {
          return false
        } else {
          return true
        }
      }
    },
    validNombreDim: function () {
      if (this.personaParam) {
        if (!util.isValidStringField(this.personaParam.mspersonanombre, this.maxchar.mspersonanombremaxchars)) {
          return false
        } else {
          return true
        }
      }
    },
    validNombreObligatorio: function () {
      if (this.personaParam) {
        if (util.isEmptyField(this.personaParam.mspersonanombre)) {
          return false
        } else {
          return true
        }
      }
    },
    validApellido1Dim: function () {
      if (this.personaParam) {
        if (!util.isValidStringField(this.personaParam.mspersonaapellido1, this.maxchar.mspersonaapellido1maxchars)) {
          return false
        } else {
          return true
        }
      }
    },
    validApellido1Obligatorio: function () {
      if (this.personaParam) {
        if (util.isEmptyField(this.personaParam.mspersonaapellido1)) {
          return false
        } else {
          return true
        }
      }
    },
    validPassObligatorio: function () {
      if (this.personaParam) {
        if (util.isEmptyField(this.pass) || util.isEmptyField(this.repPass)) {
          return false
        } else {
          return true
        }
      }
    },
    validApellido2Dim: function () {
      if (this.personaParam) {
        if (!util.isValidStringField(this.personaParam.mspersonaapellido2, this.maxchar.mspersonaapellido2maxchars)) {
          return false
        } else {
          return true
        }
      }
    },
    validDireccionDim: function () {
      if (this.personaParam) {
        if (!util.isValidStringField(this.personaParam.mspersonacalle, this.maxchar.mspersonacallemaxchars)) {
          return false
        } else {
          return true
        }
      }
    },
    validCpDim: function () {
      if (this.personaParam) {
        if (!util.isValidStringField(this.personaParam.mspersonacodpostal, this.maxchar.mspersonacodpostalmaxchars)) {
          return false
        } else {
          return true
        }
      }
    },
    validPoblacionDim: function () {
      if (this.personaParam) {
        if (!util.isValidStringField(this.personaParam.mspersonapoblacion, this.maxchar.mspersonapoblacionmaxchars)) {
          return false
        } else {
          return true
        }
      }
    },
    validEmailDim: function () {
      if (this.personaParam) {
        if (!util.isValidStringField(this.personaParam.mspersonaemail, this.maxchar.mspersonaemailmaxchars)) {
          return false
        } else {
          return true
        }
      }
    },
    validEmailFormat: function () {
      if (this.personaParam) {
        if (!util.isValidEmail(this.personaParam.mspersonaemail)) {
          return false
        } else {
          return true
        }
      }
    },
    validTelDim: function () {
      if (this.personaParam) {
        if (!util.isValidStringField(this.personaParam.mspersonatel, this.maxchar.mspersonatelmaxchars)) {
          return false
        } else {
          return true
        }
      }
    },
    validTelFormat: function () {
      if (this.personaParam) {
        if (!util.isValidTelefono(this.personaParam.mspersonatel, this.maxchar.mspersonatelmaxchars)) {
          return false
        } else {
          return true
        }
      }
    },
    validTelMovilDim: function () {
      if (this.personaParam) {
        if (!util.isValidStringField(this.personaParam.mspersonatelmovil, this.maxchar.mspersonatelmovilmaxchars)) {
          return false
        } else {
          return true
        }
      }
    },
    validTelMovilFormat: function () {
      if (this.personaParam) {
        if (!util.isValidTelefono(this.personaParam.mspersonatelmovil, this.maxchar.mspersonatelmovilmaxchars)) {
          return false
        } else {
          return true
        }
      }
    },
    validFechaNacFormat: function () {
      if (this.personaParam) {
        if (!util.isValidFecha(this.personaParam.mspersonafechanac)) {
          return false
        } else {
          return true
        }
      }
    },
    validFechaNacObligatorio: function () {
      if (this.personaParam) {
        if (util.isEmptyField(this.personaParam.mspersonafechanac)) {
          return false
        }
      }
    }
  },
  computed: {
    photoSource: function () {
      switch (this.currentStatus) {
        case this.STATUS_PHOTO.STATUS_INICIAL:
          if (this.personaParam.mspersonaimagen === null || this.personaParam.mspersonaimagen === '') {
            return require('@/assets/images/no_photo.png')
          } else {
             return `data:image/png;base64, ${this.personaParam.mspersonaimagen}`
          }
        case this.STATUS_PHOTO.STATUS_CORRECTO:
          return this.urlImagenPreview
        case this.STATUS_PHOTO.STATUS_CARGANDO:
          return this.urlImagenLoading
        default:
          break
      }
    },
  }
}
</script>
